export const SET_PROJECTS = "PROJECTS_SET_PROJECTS";
export const SET_ERROR = "PROJECTS_SET_ERROR";
export const SET_FETCHING = "PROJECTS_SET_FETCHING";
